import { render, staticRenderFns } from "./v-footer.vue?vue&type=template&id=5affca28&scoped=true"
import script from "./v-footer.vue?vue&type=script&lang=js"
export * from "./v-footer.vue?vue&type=script&lang=js"
import style0 from "./v-footer.vue?vue&type=style&index=0&id=5affca28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5affca28",
  null
  
)

export default component.exports